import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function KYCGovtOfIndia(props: any) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <G clipPath="url(#clip0_4739_7485)">
                <Path
                    d="M5.038 14.98a.61.61 0 01-.621-.625V8.541c0-.177.06-.326.18-.446a.61.61 0 01.448-.18.61.61 0 01.621.625v5.813c0 .177-.06.326-.18.446a.61.61 0 01-.448.18zm5.042 0a.61.61 0 01-.621-.625V8.541c0-.177.06-.326.18-.446a.61.61 0 01.448-.18.61.61 0 01.621.625v5.813c0 .177-.06.326-.18.446a.61.61 0 01-.448.18zM2.354 6.666a.663.663 0 01-.487-.2.663.663 0 01-.2-.488c0-.11.034-.229.104-.354a.68.68 0 01.25-.27l7.354-4.188a1.263 1.263 0 01.948-.125c.104.027.205.07.302.125l7.354 4.187c.097.056.18.146.25.271.07.125.104.243.104.354a.663.663 0 01-.2.487.663.663 0 01-.487.2H2.354zm2.104-1.25h11.084L10 2.25 4.458 5.417zM2.292 17.479a.603.603 0 01-.446-.18.61.61 0 01-.18-.448.61.61 0 01.625-.621h9.79c.03.194.054.392.075.593.021.201.073.42.156.656H2.293zm12.041-6.062V8.542c0-.177.06-.326.181-.446a.61.61 0 01.448-.18.61.61 0 01.621.625v2.25l-1.25.626zM16.667 20c-.959-.236-1.754-.788-2.386-1.656a4.79 4.79 0 01-.948-2.886V13.73c0-.113.032-.221.094-.324a.623.623 0 01.26-.238l2.709-1.354a.567.567 0 01.268-.063c.099 0 .19.02.273.063l2.709 1.354a.623.623 0 01.26.238.616.616 0 01.094.324v1.73a4.79 4.79 0 01-.948 2.885c-.632.868-1.427 1.42-2.385 1.656zm2.229-5.167a.4.4 0 000-.583.4.4 0 00-.584 0l-2.083 2.083-.937-.937a.4.4 0 00-.584 0 .4.4 0 000 .583l1.084 1.084c.07.069.14.118.21.145a.625.625 0 00.456 0 .635.635 0 00.209-.145l2.229-2.23z"
                    fill="#00813B"
                />
            </G>
            <Defs>
                <ClipPath id="clip0_4739_7485">
                    <Path fill="#fff" d="M0 0H20V20H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default KYCGovtOfIndia
